function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnelLvl3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 344.23 91.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.88,77.68s-40.15,10.64-83.76,10.64c-42.26,0-81.95-10.64-81.95-10.64l-24.45-63s53.52,11.14,106.49,11.14c51.17,0,106.3-11,106.3-11Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M172,3.27c-63.62,0-106.25,11.4-106.25,11.4A534.24,534.24,0,0,0,172.42,26c54.74,0,106.09-11.14,106.09-11.14S230.83,3.27,172,3.27Z",
    style: {
      fill: "#c6601d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.88,77.68s-40.15,10.64-83.76,10.64c-42.26,0-81.95-10.64-81.95-10.64l-24.45-63s53.52,11.14,106.49,11.14c51.17,0,106.3-11,106.3-11Z",
    style: {
      fill: "#ef7c2c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "123.39 85.99 99.76 84.39 77.86 15.01 108.97 17.5 123.39 85.99",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.67 85.99 262.33 80.06 286.48 12.57 240.09 17.5 225.67 85.99",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelLvl3);
export default __webpack_public_path__ + "static/media/funnel-lvl3.2920f2b3f1409339517db1e566eb346b.svg";
export { ForwardRef as ReactComponent };